import util from '@bmp-vue/core/api/util'

const controller = 'credor-conta'
const versao = 'v1'

export default Object.assign({}, util.GetCrud(controller, null), {
    CredorSolicitacao: function (id) {
        return util.Axios.Get(`${versao}/${controller}` + '/credor-solicitacao', id);
    }
})
